import axios  from 'axios';
import React, { useEffect, useState, useContext} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import config from '../config';
import { CategoryContext } from '../components/CategoryContext';
import Cart from './Cart';
import WishList from './WishList';
import { useSelector, useDispatch } from "react-redux";
import { selectTotalQuantity } from "../store/cartSlice";
import { clearAuthData, setAuthData } from '../store/authSlice';
import { copyFile } from 'fs';
import { clearCart } from "../store/cartSlice";
import { json } from 'stream/consumers';
import { RootState } from "../store";
import { clearWishlist } from '../store/wishlistSlice';
interface SiteInfo {
    title: string;
    name: string;
    description: string;
    logo: string;
    icon: string;
    phone: string;
    email: string;
    address: string;
    map_html: string;
    copyright_text: string;
}
interface Category {
    id: number;
    name: string;
    description: string;
    thumb: string;
    status: number;
    user_id: number;
    store_id: number;
}

interface UserData {
    type: string;
    name: string;
    email: string;
    phone: string;
    first_name: string;
    last_name: string;
    // other properties...
  }

const Header: React.FC = () => {
    // hooks
    const [siteInfo, setSiteInfo] = useState<SiteInfo | null>(null);
    const [categoryData, fetchCategoryData ] = useState<Category[]>([]);
    const [isToggled, setIsToggled] = useState(false);
    const dispatch = useDispatch();
    const totalQuantity = useSelector(selectTotalQuantity);
    const userData2 = useSelector((state: RootState) => state.auth.user);
    
    const navigate = useNavigate();
    //function for siteinfo
    const fetchSiteInfo = async () => {
        try {
            const response = await axios.get<{ data: SiteInfo }>(config.apiUrl+'siteinfo');
            if (response.status === 200) {
                setSiteInfo(response.data.data);    
                console.log('siteinfo',siteInfo);    
            } else {
                console.error('Failed to fetch site information');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleToggle = () => {
        setIsToggled((prev) => !prev);
    };

    

    const fetchCategory = async () => {
        try {
          const response = await axios.get(config.apiUrl+'category');
          console.log('category', response.data.data.data);
          if (response.status === 200) {
            fetchCategoryData(response.data.data.data);
          } else {
            console.error('Failed to fetch site information');
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };

    const userdata = JSON.parse(localStorage.getItem('user') || '{}');
    const token = localStorage.getItem('token');
    const [userData, setUserData] = useState<UserData | null>(null);
    useEffect(() => {
        fetchSiteInfo(); 
        fetchCategory();
        if(token && userdata) {
            setUserData(userdata);
        }
        // if (fetchCategoryData()) {
        //     // fetchCategoryData(); 
        //     console.log('categoryData_header', categoryData);
        // }     
              
    },[]); 

    
      // Fetch cart data from localStorage
    
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);    

  

    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
  
    useEffect(() => {
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
  
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
          setShow(false); // Hide on scroll down
        } else {
          setShow(true); // Show on scroll up
        }
  
        setLastScrollY(currentScrollY);
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [lastScrollY]);
    return (
        <div className="App">
            <div className={`header ${show ? 'visible' : 'hidden'}`}>
                <section className="header-top">
                    <div className="container">
                        <div className="manu-area d-flex justify-content-between align-items-center">
                            <div className="contact w-xl-100">
                                <Link to="/"><img className="" src='./assets/img/logo_icon.png' alt="" style={{maxWidth: '100px', marginTop: '0', height: '100px'}} /></Link>                         
                            </div>  
                            <div className="navmanu w-xl-100 h-0 w-100" >
                                <div className={`navlist p-0 m-0${isToggled ? ' open' : ''}`}>
                                    <div className="close-btn d-flex justify-content-end d-xl-none">                                        
                                        <button onClick={handleToggle} className='d-xl-none d-block close-btn-img'><img src="assets/img/menu-icon-close.png" alt=""/></button>
                                    </div>  
                                    <ul className='nav-menu-list'>
                                        <li><Link to="/">হোম </Link></li>
                                        <li><Link to="/about">আমাদের সম্পর্কে</Link></li>
                                        {/* <li><Link to="/brands">ব্রান্ড</Link></li> */}
                                        {/* <li>
                                            <Link to="/product" className="accordion-icon">পণ্য <i className="fa-solid fa-sort-down"></i></Link>
                                            <div className="dropdown">
                                                <div className="row">
                                                    {categoryData && categoryData.map((category, index) => (
                                                        <div key={index} className="col-xl-3 col-sm-12">
                                                            <ul>
                                                                <li key={index}>
                                                                    <Link to={`/product/${category.name.toUpperCase()}`}>{category.name}</Link> 
                                                                    <Link to={`/product/${category.id}`}>{category.name}</Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </li> */}
                                        <li><Link to="/contact-us">যোগাযোগ</Link></li>
                                    </ul>                         
                                </div>
                            </div>
                            <button onClick={handleToggle} className='d-xl-none d-block menu-open-btn'><img src="assets/img/menu-icon.png" alt="" /></button>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Header;
